import { viewerStore } from "viewer/store/viewer";
import { useMonitoringWarningDialog } from "../CameraView/MonitoringWarningDialog";
import { RPCResponses } from "@/modules/communication";

const { setCameraConfig, setSelectedCamera } = viewerStore();
const { Empty } = RPCResponses;

type Init = {
  faceController: FaceController;
  destroyCamera: Cb<string, Promise<void>>;
};

export default class Handlers {
  faceController!: FaceController;
  destroyCamera!: Init["destroyCamera"];

  init = ({ faceController, destroyCamera }: Init) => {
    this.faceController = faceController;
    this.destroyCamera = destroyCamera;
  };

  cameraAndFlashLightState = (cameraAndFlashLightState: CameraAndFlashlightState, from: string) => {
    setCameraConfig(from, { cameraState: cameraAndFlashLightState });
  };

  cameraAlarmStatus = (cameraAlarmStatus: CameraAlarmStatus, from: string) => {
    setCameraConfig(from, { alarmStatus: cameraAlarmStatus });
  };

  cameraVideoRecordingStatus = (cameraVideoRecordingStatus: CameraRecordingStatus, from: string) => {
    setCameraConfig(from, { videoRecordingStatus: cameraVideoRecordingStatus });
  };

  batteryStatus = (batteryStatus: BatteryStatus, from: string) => {
    setCameraConfig(from, { batteryStatus });
  };

  stopVideoBroadcasting = () => {
    useMonitoringWarningDialog.getState().open("face", "stopped");
    this.faceController.off();
  };

  // Not used?
  stopMonitoringFromCameraStation = async (request: {}, from: string, sendResponse: RpcSendResponse) => {
    setSelectedCamera({ jid: null });
    await this.destroyCamera(from);
    const response = Empty.create();
    sendResponse(response);
  };
}
